import React from 'react';
import {connect} from 'react-redux';

import PublishBreakModal from 'components/break/BreakPublish/PublishBreakModal';
import {hidePublishChallengeStatusModalAction} from "./actions";

const mapStateToProps = (state) => {
    return {
        intlPrefix: 'publish',
        isModalOpen: state.publishChallenge.showPublishChallengeStatusModal,
        validationErrors: state.publishChallenge.validationErrors,
        successful: state.publishChallenge.successful
    }
};

const mapDispatchToProps = (dispatch) => ({
    handleClose: () => dispatch(hidePublishChallengeStatusModalAction())
});

export default connect(mapStateToProps, mapDispatchToProps)(PublishBreakModal);



// WEBPACK FOOTER //
// ./public/pages/BreakPublish/PublishBreakModalContainer.jsx